
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solo",
      function () {
        return require("private-next-pages/solo.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solo"])
      });
    }
  